<template lang="pug">
transition(name="modal")
  .modal-mask
    .modal-wrapper.modal.mt-5(@click.self="$modal.close()")
      .modal-dialog(role="document")
        .modal-content
          .modal-body
            h3 You have chosen a new restaurant, in order to proceed. Your current cart will be cleared.
            h3 Do you wish to proceed?
            button.btn.btn-outline-secondary No, take me back
            button.btn.btn-primary Clear and proceed
</template>

<script>

export default {
  components: {},
  name: 'Enquiry',
  props: ['eventbus'],
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    end () {
      this.eventbus.$emit('updated', this.success)
      this.$modal.close()
    },
    tellUsNow () {
      this.isLoading = true
      .catch(e => {
        console.log(e)
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/ClearCartModal.vue